import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  useMediaQuery,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  colors,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { Image } from 'components/atoms';
import { Redirect } from 'react-router-dom';
import { SectionHeader, IconAlternate } from 'components/molecules';

const useStyles = makeStyles(theme => ({
  listItemAvatar: {
    marginRight: theme.spacing(2),
  },
  coverImage: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

const About = props => {
  const { data, className, ...rest } = props;
  const classes = useStyles();
  const [navigate, setNavigate] = React.useState(null);

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const navigateToProfile = () =>{
    setNavigate(true);
  }

  return (
    <div className={className} {...rest}>
      {navigate && <Redirect to="/profile" />}
      <Grid container spacing={4} direction={isMd ? 'row' : 'column-reverse'}>
        <Grid item xs={12} md={6} data-aos="fade-up">
          <SectionHeader
            title={
              <span>
                {!props.user ? (
                  <>
                Welcome to{' '}
                <Typography component="span" variant="inherit" color="primary">Levis.</Typography>
                <br />
                <span>Your immigration matter solve here.</span></>
                ) : (
                  <>
                  
                  Hello{' '}
                <Typography component="span" variant="inherit" color="primary">{props.user.user_firstname + ' ' + props.user.user_lastname}</Typography>
                <br />
                <span>Your immigration matter solve here.</span>
                <Button color="primary" variant="contained" onClick={navigateToProfile}><a href="#" style={{textDecoration: 'none', color: 'inherit'}}>View My Packages</a></Button>
                </>
                )}
              </span>
            }
            subtitle="We interpret and provide advice on immigration, citizenship, and business immigration issues, political asylum, and how people may secure travel, work, or student visas.  Get in touch TODAY!"
            align="left"
            disableGutter
          />
          {/* <List disablePadding>
            {data.map((item, index) => (
              <ListItem disableGutters key={index} data-aos="fade-up">
                <ListItemAvatar className={classes.listItemAvatar}>
                  <IconAlternate
                    size="small"
                    fontIconClass={item.icon}
                    color={colors.indigo}
                  />
                </ListItemAvatar>
                <ListItemText primary={item.title} secondary={item.subtitle} />
              </ListItem>
            ))}
          </List> */}
        </Grid>
        <Grid
          item
          container
          justify="center"
          alignItems="center"
          xs={12}
          md={6}
          data-aos="fade-up"
        >
          <Image
            src="https://assets.maccarianagency.com/the-front/illustrations/dashboard-drawing.svg"
            alt="..."
            className={classes.coverImage}
          />
        </Grid>
      </Grid>
    </div>
  );
};

About.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * data to be rendered
   */
  data: PropTypes.array.isRequired,
};

export default About;
